module.exports = __webpack_public_path__ + "static/media/gg-marmont-floral-jacquard-shoulder-bag-LYST_thumb.4d11e673.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/bags/gg-marmont-floral-jacquard-shoulder-bag-LYST_thumb.png
// module id = 232
// module chunks = 0